import { ReactNode, useState } from "react";
import moment from "moment";
import Modal from "react-responsive-modal";
import { mdiDelete, mdiFile, mdiFileExcelBox, mdiFilePdfBox, mdiFileWordBox, mdiImage } from "@mdi/js";
import Icon from "@mdi/react";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import cs from "date-fns/locale/cs";

registerLocale('cs', cs as any);
setDefaultLocale('cs');

export function Loading() {
    return <div className="flex-center">
        <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>;
}

export function Remove({ onRemove, children }: { children?: ReactNode, onRemove: () => void }) {
    const [remove, setRemove] = useState(false);
    return (
        <>
            <button className={`remove ${children ? "" : "icon"}`} onClick={() => setRemove(true)}>
                <Icon path={mdiDelete} size={1} /> {children}
            </button>
            <Modal center open={remove} onClose={() => setRemove(false)}>
                <h3>Opravdu smazat tuto položku?</h3>
                <div className="buttons">
                    <button
                        className="danger"
                        onClick={() => {
                            setRemove(false);
                            onRemove();
                        }}
                    >
                        Ano
                    </button>
                    <button onClick={() => setRemove(false)}>Ne</button>
                </div>
            </Modal>
        </>
    );
}

export type HeaderProps = {
    background: string, // "deska" | "dokumenty" | "kontakt" | "obce" | "region" | "vzdelavani",
    title: string,
    children?: React.ReactNode,
};

export function Header({ background, title, children }: HeaderProps) {
    return <div className={`header ${background}`}>
        <div className="background">
            <div className="content">
                <div className="title">{title}</div>
                <div className="bottom">
                    {children}
                </div>
            </div>
        </div>
    </div>
}

export function FileIcon({ url, size = 1 }: { url: string, size?: number }) {

    let path = mdiFile;
    if (url.endsWith(".pdf")) path = mdiFilePdfBox;
    if (url.endsWith(".jpg") || url.endsWith(".jpeg") || url.endsWith(".png")) path = mdiImage;
    if (url.endsWith(".doc") || url.endsWith(".docx")) path = mdiFileWordBox;

    if (url.endsWith(".xls") || url.endsWith(".xlsx")
        || url.endsWith(".csv") || url.endsWith(".tsv")) path = mdiFileExcelBox;

    return <Icon path={path} size={size} />;
}

export function Input<T extends { [key: string]: any }>({ label, name, value, textarea = false, onChange }: {
    label: string,
    name: keyof T,
    value: T,
    textarea?: boolean,
    onChange: React.Dispatch<React.SetStateAction<T>>,
}) {
    return <div>
        <label>{label}</label>
        {!textarea && <input type="text" value={value[name] as string} onChange={(e) => onChange({ ...value, [name]: e.target.value })} />}
        {textarea && <textarea value={value[name] as string} onChange={(e) => onChange({ ...value, [name]: e.target.value })} />}
    </div>
}

export function InputDate({ value, onChange }: { value: string, onChange: (value: string) => void }) {
    return <DatePicker
        locale="cs"
        showIcon
        showYearDropdown
        showMonthDropdown
        dateFormat="dd. MMMM YYYY"
        selected={new Date(value)}
        onChange={date => {
            if (date) onChange(moment(date).format("YYYY-MM-DD"))
        }}
    />;
}
export function InputDateTime({ value, onChange }: { value: string, onChange: (value: string) => void }) {
    return <DatePicker
        locale="cs"
        showIcon
        showYearDropdown
        showMonthDropdown
        showTimeSelect
        dateFormat="dd. MMMM YYYY HH:mm"
        timeFormat="HH:mm"
        selected={new Date(value)}
        onChange={date => {
            if (date) onChange(moment(date).format("YYYY-MM-DDTHH:mm"))
        }}
    />;
}
